import {Injectable} from "@angular/core";
import {Category} from "@app/core/category/domain/category";
import {Observable} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export abstract class CategoryRemote {
    public abstract getMainCategories(): Observable<Category[]>;
    public abstract getCategories(): Observable<Category[]>;
}